<template>
    <div>
        <el-container id="nhMainPhone">
            <!-- <el-header class="phoneHeader"></el-header> -->
            <div class="topButton">
                <el-button class="custom-el-button" type="primary" size="medium" @click="showHomePage">
                    <i class="el-icon-s-home"></i> 首页
                </el-button>
            </div>

            <!-- 实习信息 返校记录:返校时间 主题 操作 实习周记 现场指导
            通知公告轮播
            按钮：成绩评定+实习信息 -->
            <el-main class="phoneMainBox">
                <el-tabs v-model="activeName" @tab-click="handleClick" :tab-position="tabPosition">
                    <el-tab-pane name="first">
                        <span slot="label" class="tabTitleBox"><i class="el-icon-user"></i> 实习信息</span>
                        <div class="phoneMain">
                            <div class="phoneTitle">
                                <h3><i class="el-icon-user"></i>&nbsp;实习信息</h3>
                            </div>
                            <el-carousel :interval="5000" arrow="never" style="overflow-y:hidden">
                                <div v-if="notificationData.length>4">
                                    <el-carousel-item v-for="index in 4" :key="index"
                                                      @click.native="notificationDetail(notificationData[index-1])">
                                        <h3>{{ notificationData[index - 1].title }}</h3>
                                    </el-carousel-item>
                                </div>

                                <div v-else>
                                    <el-carousel-item v-for="(item,index) in notificationData" :key="item"
                                                      @click.native="notificationDetail(item)">
                                        <template>
                                            <h3>{{ item.title }}</h3>
                                        </template>
                                    </el-carousel-item>
                                </div>

                                <el-button v-if="notificationData.length>4" type="text"
                                           style="position: absolute;z-index: 999;right: 6vh;bottom: -4px" size="small"
                                           @click="moreNotification">
                                    <span style="font-weight: bold;font-size: 15px;color: white">・・・</span>
                                </el-button>

                            </el-carousel>
                            <div class="iconBtnGroup">
                                <div class="iconBtn" @click="info"><i class="el-icon-receiving"></i>
                                    <p>个人实习信息</p></div>
                                <div class="iconBtn" @click="apply"><i class="el-icon-phone-outline"></i>
                                    <p>自主联系申请</p></div>
                                <div class="iconBtn" @click="change"><i class="el-icon-refresh"></i>
                                    <p>实习变更申请</p></div>
                                <div class="iconBtn" @click="complete"><i class="el-icon-edit-outline"></i>
                                    <p>信息补全</p></div>
                                <div class="iconBtn" @click="report"><i class="el-icon-document"></i>
                                    <p>实习报告</p></div>
                                <div class="iconBtn" @click="evaluation"><i class="el-icon-pie-chart"></i>
                                    <p>成绩评定</p></div>
                            </div>
                        </div>
                        <div class="phoneMain">
                            <div class="phoneTitle twoTitle">
                                <h3>共享文件</h3>
                            </div>
                            <div class="phoneList">
                                <div class="phoneListCard">
                                    <div class="listCard" v-for="(item,index) in fileData">
                                        <div class="listCardText">
                                            <el-descriptions class="margin-top" title="" :column="1">
                                                <el-descriptions-item label="文件名">{{
                                                        item.fileName
                                                    }}
                                                </el-descriptions-item>
                                            </el-descriptions>
                                        </div>
                                        <div class="listCardBtn">
                                            <el-button type="primary" size="small" @click="fileDownload(item)">下载
                                            </el-button>
                                            <el-button type="primary" size="small" @click="fileShow(item)">预览
                                            </el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane name="second">
                        <span slot="label" class="tabTitleBox"><i class="el-icon-notebook-1"></i> 实习周记</span>
                        <div class="phoneMain">
                            <div class="phoneTitle">
                                <h3><i class="el-icon-notebook-1"></i> 实习周记</h3>
                            </div>
                            <div class="phoneList">
                                <div class="phoneListCard">
                                    <div class="listCard" v-for="(item,index) in summaryData">
                                        <div class="listCardText">
                                            <el-descriptions class="margin-top" title="" :column="1">
                                                <el-descriptions-item label="时间范围">{{
                                                        timeRangeFormatter(item)
                                                    }}
                                                </el-descriptions-item>
                                                <el-descriptions-item label="提交状态">{{
                                                        submitStateFormatter(item)
                                                    }}
                                                </el-descriptions-item>
                                                <el-descriptions-item label="评阅状态">{{
                                                        evaluateStateFormatter(item)
                                                    }}
                                                </el-descriptions-item>
                                            </el-descriptions>
                                        </div>
                                        <div class="listCardBtn">
                                            <el-button
                                                v-if="item.submitState === '0' || item.submitState == ''"
                                                type="warning" size="small" @click="summaryEdit(item)">编辑
                                            </el-button>
                                            <el-button v-if="item.submitState === '1'" type="info"
                                                       size="small" @click="summaryDetail(item)">详情
                                            </el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane name="third">
                        <span slot="label" class="tabTitleBox"><i class="el-icon-data-analysis"></i> 现场指导</span>
                        <div class="phoneMain">
                            <div class="phoneTitle">
                                <h3><i class="el-icon-data-analysis"></i> 现场指导</h3>
                            </div>
                            <div class="phoneList">
                                <div class="phoneListCard">
                                    <div class="listCard" v-for="(item,index) in guidanceData">
                                        <div class="listCardText">
                                            <el-descriptions class="margin-top" title="" :column="1">
                                                <el-descriptions-item label="指导老师">{{
                                                        item.teaName
                                                    }}
                                                </el-descriptions-item>
                                                <el-descriptions-item label="指导时间">{{
                                                        item.time
                                                    }}
                                                </el-descriptions-item>
                                            </el-descriptions>
                                        </div>
                                        <div class="listCardBtn">
                                            <el-button type="info" size="small" @click="guidanceDetail(item)">详情
                                            </el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane name="four">
                        <span slot="label" class="tabTitleBox"><i class="el-icon-date"></i> 返校记录</span>
                        <div class="phoneMain">
                            <div class="phoneTitle">
                                <h3><i class="el-icon-date"></i> 返校记录</h3>
                            </div>
                            <div class="phoneList">
                                <div class="phoneListCard">
                                    <div class="listCard" v-for="(item,index) in homecomingData">
                                        <div class="listCardText">
                                            <el-descriptions class="margin-top" title="" :column="1">
                                                <el-descriptions-item label="返校时间">{{ item.time }}
                                                </el-descriptions-item>
                                                <el-descriptions-item label="出勤状态">{{
                                                        parseAttendance(item)
                                                    }}
                                                </el-descriptions-item>
                                            </el-descriptions>
                                        </div>
                                        <div class="listCardBtn">
                                            <el-button type="info" size="small" @click="homecomingDetail(item)">详情
                                            </el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </el-main>
        </el-container>

        <div class="components-container" id="mobileViewPort">
            <div id="mobileMode" style="height: 0">
                <el-dialog id="mainDialog" class="formDialog" title="个人实习信息" :visible.sync="infoDialogVisible"
                           width="90%">
                    <el-scrollbar id="infoDialogScroll" ref="infoDialogScroll">
                        <el-form label-width="130px" label-position="left" width="100%">
                            <el-form-item label="学生">
                                {{ user.userCode }} - {{ user.userName }}
                            </el-form-item>
                            <el-form-item label="实习单位名称">
                                {{ stuPracticeInfo.unitName }}
                            </el-form-item>

                            <el-form-item label="实习岗位名称">
                                {{ stuPracticeInfo.postName }}
                            </el-form-item>
                            <el-form-item label="学生手机号">
                                {{ stuPracticeInfo.stuPhone }}
                            </el-form-item>
                            <el-form-item label="家庭电话">
                                {{ stuPracticeInfo.homeTel }}
                            </el-form-item>
                            <el-form-item label="实习推荐类型">
                                {{ parsePracticeType(stuPracticeInfo.typeCode) }}
                            </el-form-item>
                            <el-form-item label="实习薪资">
                                {{ stuPracticeInfo.salary }}
                            </el-form-item>
                            <el-form-item label="入学前户籍信息">
                                {{ stuPracticeInfo.censusRegisterInfo }}
                            </el-form-item>
                            <el-form-item label="实习期间居住地址">
                                {{ stuPracticeInfo.residentialAddress }}
                            </el-form-item>
                            <el-form-item label="实习开始时间">
                                {{ stuPracticeInfo.beginTime }}
                            </el-form-item>
                            <el-form-item label="实习结束时间">
                                {{ stuPracticeInfo.endTime }}
                            </el-form-item>
                            <el-form-item label="学生邮箱">
                                {{ stuPracticeInfo.stuEmail }}
                            </el-form-item>
                            <el-form-item label="是否提供住宿">
                                {{ parseSf(stuPracticeInfo.putUp) }}
                            </el-form-item>
                            <el-form-item label="是否岗位对口">
                                {{ parseSf(stuPracticeInfo.counterpart) }}
                            </el-form-item>
                            <el-form-item label="是否安排带教">
                                {{ parseSf(stuPracticeInfo.teaching) }}
                            </el-form-item>
                            <el-form-item label="单位联系人姓名">
                                {{ stuPracticeInfo.unitContactsName }}
                            </el-form-item>
                            <el-form-item label="单位联系人职务">
                                {{ stuPracticeInfo.unitContactsDuty }}
                            </el-form-item>
                            <el-form-item label="单位联系人电话">
                                {{ stuPracticeInfo.unitContactsTel }}
                            </el-form-item>
                            <el-form-item label="单位联系人邮箱">
                                {{ stuPracticeInfo.unitContactsEmail }}
                            </el-form-item>
                            <el-form-item label="单位地址">
                                {{ stuPracticeInfo.unitAddress }}
                            </el-form-item>

                        </el-form>
                    </el-scrollbar>
                </el-dialog>

                <el-dialog id="mainDialog" class="formDialog" :visible.sync="applyListDialogVisible" width="90%">
                    <template slot="title">
                        <span style="font-size: 18px;font-weight: bold">自主联系申请</span>
                        <button
                            style="background-color: #67C23A;border: none;margin-left: 10px;width: 50px;height: 30px"
                            @click="newApply"><span style="font-size: 12px;color: #FFFFFF">申请</span></button>
                    </template>
                    <div id="listArea" style="padding: 10px 20px;height: 65vh">
                        <div class="cardMain" v-for="(item,index) in applyData" :key="index">
                            <div class="cardText">
                                <p><label for="">单位名称</label>{{ item.unitName }}</p>
                                <p><label for="">岗位名称</label>{{ item.postName }}</p>
                                <p><label for="">创建时间</label>{{ item.time }}</p>
                                <div class="auditStateImg">
                                    <img :src="loadStateImg(item)" alt="">
                                </div>
                            </div>
                            <div class="cardInput">
                                <el-button v-if="item.submitState == '0' && item.auditState != '2'"
                                           type="warning"
                                           size="small" @click="applyMod(item,'set');">编辑
                                </el-button>
                                <el-button v-if="item.submitState == '0' && item.auditState != '2'"
                                           type="danger"
                                           size="small" @click="applyDel(item);">删除
                                </el-button>
                                <el-button v-if="item.submitState=='1' || item.auditState == '2'"
                                           type="info"
                                           size="small" @click="applyMod(item,'view');">详情
                                </el-button>
                                <el-button
                                    v-if="item.submitState=='1' || item.auditState=='1'|| item.auditState=='2'"
                                    size="small" @click="showAuditList(item.id);">审核信息
                                </el-button>
                            </div>
                        </div>
                    </div>
                </el-dialog>

                <el-dialog class="formDialog" title="审核信息" :visible.sync="auditListDialogVisible"
                           v-if="auditListDialogVisible" width="90%">
                    <div>
                        <auditList ref="auditList" :relatedCode="auditRelatedCode" :listHeight="450"></auditList>
                    </div>
                </el-dialog>

                <el-dialog class="formDialog" :visible.sync="applyDialogVisible" v-if="applyDialogVisible" width="90%"
                           @closed="closeApply">
                    <template slot="title">
                        <span style="font-size: 18px;font-weight: bold">{{ applyDialogTitle }}</span>
                        <span style="margin-left: 10px">{{ applySubmitStr }}</span>
                        <span :style="{'color': applyAuditStrColor,'margin-left': '10px'}">{{ applyAuditStr }}</span>
                        <button
                            style="background-color: white;border-width: 1px;border-color: #D3D3D3;margin-left: 10px;width: 70px;height: 30px"
                            @click="showAuditList(applyForm.id)"><span
                            style="font-size: 12px;color: #606266">审核信息</span></button>
                    </template>
                    <el-scrollbar id="infoDialogScroll" ref="infoDialogScroll">
                        <el-form label-width="130px" label-position="left" width="100%" ref="applyForm"
                                 :model="applyForm"
                                 :rules="applyRules">
                            <el-form-item label="学生" prop="stuCode">
                                {{ applyForm.stuName + ' - ' + applyForm.stuCode }}
                            </el-form-item>
                            <el-form-item label="入学前户籍信息" prop="censusRegisterInfo">
                                <el-input v-if="applyFlag" v-model="applyForm.censusRegisterInfo" style="width: 100%"
                                          maxlength="200"/>
                                <span v-if="!applyFlag">{{ applyForm.censusRegisterInfo }}</span>
                            </el-form-item>
                            <el-form-item label="实习期间居住地址" prop="residentialAddress">
                                <el-input v-if="applyFlag" v-model="applyForm.residentialAddress" style="width: 100%"
                                          maxlength="200"/>
                                <span v-if="!applyFlag">{{ applyForm.residentialAddress }}</span>
                            </el-form-item>
                            <el-form-item label="家庭电话" prop="homeTel">
                                <el-input v-if="applyFlag" v-model="applyForm.homeTel" style="width: 100%"
                                          maxlength="50"/>
                                <span v-if="!applyFlag">{{ applyForm.homeTel }}</span>
                            </el-form-item>
                            <el-form-item label="学生手机号" prop="stuPhone">
                                <el-input v-if="applyFlag" v-model="applyForm.stuPhone" style="width: 100%"
                                          maxlength="50"/>
                                <span v-if="!applyFlag">{{ applyForm.stuPhone }}</span>
                            </el-form-item>
                            <el-form-item label="学生邮箱" prop="stuEmail">
                                <el-input v-if="applyFlag" v-model="applyForm.stuEmail" style="width: 100%"
                                          maxlength="100"/>
                                <span v-if="!applyFlag">{{ applyForm.stuEmail }}</span>
                            </el-form-item>
                            <el-form-item label="实习单位名称" prop="unitName">
                                <el-input v-if="applyFlag" v-model="applyForm.unitName" style="width: 100%"
                                          maxlength="200"/>
                                <span v-if="!applyFlag">{{ applyForm.unitName }}</span>
                            </el-form-item>

                            <el-form-item label="实习岗位名称" prop="postName">
                                <el-input v-if="applyFlag" v-model="applyForm.postName" style="width: 100%"
                                          maxlength="50"/>
                                <span v-if="!applyFlag">{{ applyForm.postName }}</span>
                            </el-form-item>
                            <el-form-item label="实习开始时间" prop="beginTime">
                                <el-date-picker v-if="applyFlag" v-model="applyForm.beginTime" type="date"
                                                style="width: 100%"
                                                value-format="yyyy-MM-dd" placeholder="选择日期"/>
                                <span v-if="!applyFlag">{{ applyForm.beginTime }}</span>
                            </el-form-item>
                            <el-form-item label="实习结束时间" prop="endTime">
                                <el-date-picker v-if="applyFlag" v-model="applyForm.endTime" type="date"
                                                style="width: 100%"
                                                value-format="yyyy-MM-dd" placeholder="选择日期"/>
                                <span v-if="!applyFlag">{{ applyForm.endTime }}</span>
                            </el-form-item>
                            <el-form-item label="实习薪资" prop="salary">
                                <el-input-number v-if="applyFlag" v-model="applyForm.salary" :precision="2" :step="10"
                                                 :min="0"
                                                 :max="1000000"
                                                 style="width:100%;"/>
                                <span v-if="!applyFlag">{{ applyForm.salary }}</span>
                            </el-form-item>
                            <el-form-item label="是否岗位对口" prop="counterpart">
                                <el-select v-if="applyFlag" v-model="applyForm.counterpart" filterable placeholder="请选择"
                                           style="width:100%;" clearable>
                                    <el-option v-for="item in comboOption.sf" :key="item.comboValue"
                                               :label="item.comboName"
                                               :value="item.comboValue">
                                    </el-option>
                                </el-select>
                                <span v-if="!applyFlag">{{ parseSf(applyForm.counterpart) }}</span>
                            </el-form-item>
                            <el-form-item label="是否安排带教" prop="teaching">
                                <el-select v-if="applyFlag" v-model="applyForm.teaching" filterable placeholder="请选择"
                                           style="width:100%;"
                                           clearable>
                                    <el-option v-for="item in comboOption.sf" :key="item.comboValue"
                                               :label="item.comboName"
                                               :value="item.comboValue">
                                    </el-option>
                                </el-select>
                                <span v-if="!applyFlag">{{ parseSf(applyForm.teaching) }}</span>
                            </el-form-item>
                            <el-form-item label="是否提供住宿" prop="putUp">
                                <el-select v-if="applyFlag" v-model="applyForm.putUp" filterable placeholder="请选择"
                                           style="width:100%;"
                                           clearable>
                                    <el-option v-for="item in comboOption.sf" :key="item.comboValue"
                                               :label="item.comboName"
                                               :value="item.comboValue">
                                    </el-option>
                                </el-select>
                                <span v-if="!applyFlag">{{ parseSf(applyForm.putUp) }}</span>
                            </el-form-item>
                            <el-form-item label="单位联系人姓名" prop="unitContactsName">
                                <el-input v-if="applyFlag" v-model="applyForm.unitContactsName" style="width: 100%"
                                          maxlength="50"/>
                                <span v-if="!applyFlag">{{ applyForm.unitContactsName }}</span>
                            </el-form-item>
                            <el-form-item label="单位联系人职务" prop="unitContactsDuty">
                                <el-input v-if="applyFlag" v-model="applyForm.unitContactsDuty" style="width: 100%"
                                          maxlength="50"/>
                                <span v-if="!applyFlag">{{ applyForm.unitContactsDuty }}</span>
                            </el-form-item>
                            <el-form-item label="单位联系人电话" prop="unitContactsTel">
                                <el-input v-if="applyFlag" v-model="applyForm.unitContactsTel" style="width: 100%"
                                          maxlength="50"/>
                                <span v-if="!applyFlag">{{ applyForm.unitContactsTel }}</span>
                            </el-form-item>
                            <el-form-item label="单位联系人邮箱" prop="unitContactsEmail">
                                <el-input v-if="applyFlag" v-model="applyForm.unitContactsEmail" style="width: 100%"
                                          maxlength="100"/>
                                <span v-if="!applyFlag">{{ applyForm.unitContactsEmail }}</span>
                            </el-form-item>
                            <el-form-item label="单位地址" prop="unitAddress">
                                <el-input v-if="applyFlag" v-model="applyForm.unitAddress" style="width: 100%"
                                          maxlength="100"/>
                                <span v-if="!applyFlag">{{ applyForm.unitAddress }}</span>
                            </el-form-item>

                        </el-form>
                    </el-scrollbar>
                    <div slot="footer" class="dialog-footer text-center">
                        <el-button v-if="applyFlag" type="primary" @click="applySave">保 存</el-button>
                        <el-button v-if="applyFlag" type="warning" @click="applySubmit">提 交</el-button>
                        <el-button v-if="applyDelFlag" type="danger" @click="applyDel">删 除</el-button>
                        <el-button @click="applyDialogVisible = false">取 消</el-button>
                    </div>
                </el-dialog>

                <el-dialog id="mainDialog" class="formDialog" :visible.sync="changeDialogVisible" width="90%">
                    <template slot="title">
                        <span style="font-size: 18px;font-weight: bold">实习变更申请</span>
                        <button
                            style="background-color: #67C23A;border: none;margin-left: 10px;width: 50px;height: 30px"
                            @click="newChange"><span style="font-size: 12px;color: #FFFFFF">申请</span></button>
                    </template>

                    <div id="listArea" style="padding: 10px 20px;height: 65vh">
                        <div class="cardMain" v-for="(item,index) in changeData" :key="index">
                            <div class="cardText">
                                <p><label for="">单位名称</label>{{ item.unitName }}</p>
                                <p><label for="">岗位名称</label>{{ item.postName }}</p>
                                <p><label for="">创建时间</label>{{ item.time }}</p>
                                <div class="auditStateImg">
                                    <img :src="loadStateImg(item)" alt="">
                                </div>
                            </div>
                            <div class="cardInput">
                                <el-button v-if="item.submitState == '0'"
                                           type="warning"
                                           size="small" @click="changeMod(item,'set');">编辑
                                </el-button>
                                <el-button v-if="item.submitState == '0'"
                                           type="danger"
                                           size="small" @click="changeDel(item);">删除
                                </el-button>
                                <el-button v-if="item.submitState=='1'"
                                           type="info"
                                           size="small" @click="changeMod(item,'view');">详情
                                </el-button>
                                <el-button
                                    v-if="item.submitState=='1' || item.auditState=='1'|| item.auditState=='2'"
                                    size="small" @click="showAuditList(item.id);">审核信息
                                </el-button>
                            </div>
                        </div>
                    </div>
                </el-dialog>


                <el-dialog :title="addChangeDialogTitle" class="formDialog" :visible.sync="addChangeDialogVisible"
                           width="90%" @closed="closeAddChange">
                    <el-scrollbar id="infoDialogScroll" ref="infoDialogScroll">
                        <el-form label-width="140px" label-position="left" width="100%" ref="changeForm"
                                 :model="changeForm"
                                 :rules="changeRules">
                            <el-form-item label="学生">
                                {{ stuPracticeInfo.stuName + ' - ' + stuPracticeInfo.stuCode }}
                            </el-form-item>

                            <el-form-item label="原实习单位名称">
                                {{ changeForm.unitName }}
                            </el-form-item>
                            <el-form-item label="现实习单位名称" prop="newUnitName">
                                <el-input v-if="changeFlag" v-model="changeForm.newUnitName" style="width: 100%"
                                          maxlength="200"/>
                                <span v-if="!changeFlag">{{ changeForm.newUnitName }}</span>
                            </el-form-item>
                            <el-form-item label="原实习岗位名称">
                                {{ changeForm.postName }}
                            </el-form-item>
                            <el-form-item label="现实习岗位名称" prop="newPostName">
                                <el-input v-if="changeFlag" v-model="changeForm.newPostName" style="width: 100%"
                                          maxlength="50"/>
                                <span v-if="!changeFlag">{{ changeForm.newPostName }}</span>
                            </el-form-item>
                            <el-form-item label="原实习开始时间">
                                {{ changeForm.beginTime }}
                            </el-form-item>
                            <el-form-item label="现实习开始时间" prop="newBeginTime">
                                <el-date-picker v-if="changeFlag" v-model="changeForm.newBeginTime" type="date"
                                                style="width: 100%"
                                                value-format="yyyy-MM-dd" placeholder="选择日期"/>
                                <span v-if="!changeFlag">{{ changeForm.newBeginTime }}</span>
                            </el-form-item>
                            <el-form-item label="原实习结束时间">
                                {{ changeForm.endTime }}
                            </el-form-item>
                            <el-form-item label="现实习结束时间" prop="newEndTime">
                                <el-date-picker v-if="changeFlag" v-model="changeForm.newEndTime" type="date"
                                                style="width: 100%" value-format="yyyy-MM-dd" placeholder="选择日期"/>
                                <span v-if="!changeFlag">{{ changeForm.newEndTime }}</span>
                            </el-form-item>
                            <el-form-item label="原实习薪资">
                                {{ changeForm.salary }}
                            </el-form-item>
                            <el-form-item label="现实习薪资" prop="newSalary">
                                <el-input-number v-if="changeFlag" v-model="changeForm.newSalary" :precision="2"
                                                 :step="10"
                                                 :min="0"
                                                 :max="1000000"
                                                 style="width:100%;"/>
                                <span v-if="!changeFlag">{{ changeForm.newSalary }}</span>
                            </el-form-item>
                            <el-form-item label="原是否岗位对口">
                                {{ parseSf(changeForm.counterpart) }}
                            </el-form-item>
                            <el-form-item label="现是否岗位对口" prop="newCounterpart">
                                <el-select v-if="changeFlag" v-model="changeForm.newCounterpart" filterable
                                           placeholder="请选择" style="width:100%;"
                                           clearable>
                                    <el-option v-for="item in comboOption.sf" :key="item.comboValue"
                                               :label="item.comboName"
                                               :value="item.comboValue">
                                    </el-option>
                                </el-select>
                                <span v-if="!changeFlag">{{ parseSf(changeForm.newCounterpart) }}</span>
                            </el-form-item>
                            <el-form-item label="原是否提供住宿">
                                {{ parseSf(changeForm.putUp) }}
                            </el-form-item>
                            <el-form-item label="现是否提供住宿" prop="newPutUp">
                                <el-select v-if="changeFlag" v-model="changeForm.newPutUp" filterable placeholder="请选择"
                                           style="width:100%;"
                                           clearable>
                                    <el-option v-for="item in comboOption.sf" :key="item.comboValue"
                                               :label="item.comboName"
                                               :value="item.comboValue">
                                    </el-option>
                                </el-select>
                                <span v-if="!changeFlag">{{ parseSf(changeForm.newPutUp) }}</span>
                            </el-form-item>
                            <el-form-item label="原单位联系人姓名">
                                {{ changeForm.unitContactsName }}
                            </el-form-item>
                            <el-form-item label="现单位联系人姓名" prop="newUnitContactsName">
                                <el-input v-if="changeFlag" v-model="changeForm.newUnitContactsName" style="width: 100%"
                                          maxlength="50"/>
                                <span v-if="!changeFlag">{{ changeForm.newUnitContactsName }}</span>
                            </el-form-item>
                            <el-form-item label="原单位联系人职务">
                                {{ changeForm.unitContactsDuty }}
                            </el-form-item>
                            <el-form-item label="现单位联系人职务" prop="newUnitContactsDuty">
                                <el-input v-if="changeFlag" v-model="changeForm.newUnitContactsDuty" style="width: 100%"
                                          maxlength="50"/>
                                <span v-if="!changeFlag">{{ changeForm.newUnitContactsDuty }}</span>
                            </el-form-item>
                            <el-form-item label="原单位联系人电话">
                                {{ changeForm.unitContactsTel }}
                            </el-form-item>
                            <el-form-item label="现单位联系人电话" prop="newUnitContactsTel">
                                <el-input v-if="changeFlag" v-model="changeForm.newUnitContactsTel" style="width: 100%"
                                          maxlength="50"/>
                                <span v-if="!changeFlag">{{ changeForm.newUnitContactsTel }}</span>
                            </el-form-item>
                            <el-form-item label="原单位联系人邮箱">
                                {{ changeForm.unitContactsEmail }}
                            </el-form-item>
                            <el-form-item label="现单位联系人邮箱" prop="newUnitContactsEmail">
                                <el-input v-if="changeFlag" v-model="changeForm.newUnitContactsEmail"
                                          style="width: 100%"
                                          maxlength="100"/>
                                <span v-if="!changeFlag">{{ changeForm.newUnitContactsEmail }}</span>
                            </el-form-item>
                            <el-form-item label="原单位地址">
                                {{ changeForm.unitAddress }}
                            </el-form-item>
                            <el-form-item label="现单位地址" prop="newUnitAddress">
                                <el-input v-if="changeFlag" v-model="changeForm.newUnitAddress" style="width: 100%"
                                          maxlength="100"/>
                                <span v-if="!changeFlag">{{ changeForm.newUnitAddress }}</span>
                            </el-form-item>
                        </el-form>
                    </el-scrollbar>
                    <div slot="footer" class="dialog-footer text-center">
                        <el-button v-if="changeFlag" type="primary" @click="changeSave">保 存</el-button>
                        <el-button v-if="changeFlag" type="warning" @click="changeSubmit">提 交</el-button>
                        <el-button @click="addChangeDialogVisible = false">取 消</el-button>
                    </div>
                </el-dialog>

                <el-dialog id="mainDialog" title="信息补全" class="formDialog" :visible.sync="completeDialogVisible"
                           width="90%">
                    <el-scrollbar id="infoDialogScroll" ref="infoDialogScroll" style="height: 35vh">
                        <el-form label-width="130px" label-position="left" width="100%">
                            <el-form-item label="学生" prop="stuCode">
                                {{ completeForm.stuName + ' - ' + completeForm.stuCode }}
                            </el-form-item>
                            <el-form-item label="实习期间居住地址" prop="residentialAddress">
                                <el-input v-model="completeForm.residentialAddress" style="width: 100%"
                                          maxlength="200"/>
                            </el-form-item>
                            <el-form-item label="家庭电话" prop="homeTel">
                                <el-input v-model="completeForm.homeTel" style="width: 100%" maxlength="50"/>
                            </el-form-item>
                            <el-form-item label="学生手机号" prop="stuPhone">
                                <el-input v-model="completeForm.stuPhone" style="width: 100%" maxlength="50"/>
                            </el-form-item>
                            <el-form-item label="学生邮箱" prop="stuEmail">
                                <el-input v-model="completeForm.stuEmail" style="width: 100%" maxlength="100"/>
                            </el-form-item>
                        </el-form>
                    </el-scrollbar>
                    <div slot="footer" class="dialog-footer text-center">
                        <el-button type="primary" @click="completeSave" size="small">保 存</el-button>
                        <el-button @click="completeDialogVisible = false" size="small">取 消</el-button>
                    </div>
                </el-dialog>

                <el-dialog class="formDialog" title="实习报告" v-if="reportListDialogVisible"
                           :visible.sync="reportListDialogVisible" @close="delFile">
                    <div id="infoDialogScroll" ref="infoDialogScroll" style="overflow: auto">
                        <report style="margin-top: 10px;height: 50vh" ref="report" :stu-code="user.userCode"
                                user-type="stu" type="mobile"
                                previewDialogWidth="90%"/>
                    </div>
                </el-dialog>

                <el-dialog class="formDialog" title="成绩评定" v-if="evaluationDialogVisible"
                           :visible.sync="evaluationDialogVisible">
                    <el-form label-width="0px" label-position="left" v-if="evaluationState">
                        <table class="configArea">
                            <tr style="border-bottom: 1px solid #EBEEF5;border-top: 1px solid #EBEEF5;">
                                <td v-if="evaluationState">
                                    <el-form-item>
                                    <span
                                        style="font-size: 18px;color: #606266;font-weight: bold;padding-left: 10px">总分</span>
                                        <span style="font-size: 18px;padding-left: 20px">{{
                                                evaluationCountScore
                                            }}</span>
                                    </el-form-item>
                                </td>
                            </tr>
                        </table>
                    </el-form>

                    <div style="height: 500px;overflow: auto;padding: 10px 20px">
                        <el-container class="register-container" v-if="evaluationState">
                            <el-container>
                                <el-aside width="100%">
                                    <div class="config-container">
                                        <el-form label-width="120px" label-position="left">
                                            <div v-for="(item,index) in evaluationData">
                                                <div v-if="index !== 0" style="margin-top: 20px"/>
                                                <div class="areaTitle">
                                                    <table class="configArea">
                                                        <tr style="border-bottom: 1px solid #EBEEF5;">
                                                            <td style="background-color: #EDF1F2">
                                                    <span
                                                        style="font-size: 18px;font-weight: bold;padding-left: 10px;line-height: 30px;">
                                                        评定项
                                                    </span>
                                                            </td>
                                                        </tr>
                                                        <tr style="border-bottom: 1px solid #EBEEF5;">
                                                            <td>
                                                                <el-form-item label="评定项名称">
                                                                    {{ item.name }}（{{ item.radio }}%）
                                                                </el-form-item>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <el-form label-position="top">
                                                                    <el-form-item label="评定项说明">
                                                                        {{ item.content }}
                                                                    </el-form-item>
                                                                </el-form>
                                                            </td>
                                                        </tr>
                                                        <td colspan="2" style="background-color: #EDF1F2">
                                                    <span
                                                        style="font-size: 18px;font-weight: bold;padding-left: 10px;line-height: 30px">
                                                        评定项明细
                                                    </span>
                                                        </td>
                                                    </table>
                                                </div>
                                                <table v-for="(i,subIndex) in item.list" class="configArea">
                                                    <el-form-item label="评定项明细名称">
                                                        {{ i.name }}（{{ i.upper }}）
                                                    </el-form-item>
                                                    <el-form-item label="评定项明细说明">
                                                        {{ i.content }}
                                                    </el-form-item>
                                                    <el-form-item label="成绩">
                                                        <span>{{ i.score }}</span>
                                                    </el-form-item>
                                                    <el-form-item label="成绩评定说明">
                                                        <span>{{ i.scoreContent }}</span>
                                                    </el-form-item>
                                                    <div style="width: 35vh;">
                                                        <el-divider/>
                                                    </div>
                                                </table>
                                                <table class="configArea">
                                                    <tr class="configRow">
                                                        <td/>
                                                        <td width="50%">
                                                            <el-form-item label="总分">
                                                                <span>{{ item.score }}</span>
                                                            </el-form-item>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </el-form>
                                    </div>
                                </el-aside>
                            </el-container>
                        </el-container>
                        <div v-else
                             style="width:100%; text-align:center; font-size:18px; font-weight:bold; color:#a7a8ac; margin-top:10%;">
                            暂无成绩评定信息
                        </div>
                    </div>
                </el-dialog>

                <el-dialog :title="fileName" :visible.sync="previewerDialogVisible" v-if="previewerDialogVisible"
                           width="90%"
                           top="3vh" append-to-body>
                    <div style="height:680px;">
                        <previewer ref="previewer" :fileInfo="fileInfo" :height="650"></previewer>
                    </div>
                </el-dialog>

                <el-dialog class="formDialog" :visible.sync="summaryDialogVisible"
                           width="90%" v-if="summaryDialogVisible" :close-on-press-escape="false"
                           :close-on-click-modal="false">
                    <template slot="title">
                        <span style="font-size: 18px;font-weight: bold">{{ summaryDialogTitle }}</span>
                        <span style="font-size: 14px">{{ summaryDialogTitleDate }}</span>
                    </template>
                    <div id="infoDialogScroll" ref="infoDialogScroll" style="height: 75vh;overflow: auto">
                        <summarys ref="summary" :summaryForm="summaryForm" :summaryFlag="summaryFlag" dialogWidth="90%"
                                  :userCode="this.user.userCode"
                                  userType="stu" type="mobile" @callback="summaryCallback"/>
                    </div>
                </el-dialog>

                <el-dialog class="formDialog" title="现场指导" v-if="guidanceDialogVisible"
                           :visible.sync="guidanceDialogVisible" top="50px">
                    <div style="height: 65vh;overflow: auto;padding-right: 10px">
                        <recordTable ref="recordTable" user-type="stu" :id="guidanceId" style="margin-left: 20px"
                                     dialogWidth="90%" type="mobile"/>
                    </div>
                    <br/>
                </el-dialog>

                <el-dialog class="formDialog" title="详情" v-if="homecomingDetailDialogVisible"
                           :visible.sync="homecomingDetailDialogVisible">
                    <div id="infoDialogScroll" ref="infoDialogScroll" style="overflow: auto">
                        <homecomingRecord ref="homecomingRecord" :user-code="user.userCode" user-type="stu"
                                          dialogWidth="90%" type="mobile"
                                          :id="homecomingId"/>
                        <br/>
                    </div>
                </el-dialog>

                <el-dialog class="formDialog" title="详情" :visible.sync="notificationDialogVisible"
                           width="90%">
                    <div id="infoDialogScroll" ref="infoDialogScroll" style="height:450px; overflow:auto;">
                        <el-form label-width="80px" label-position="left">
                            <el-form-item label="标题">
                                <span>{{ notificationTitle }}</span>
                            </el-form-item>
                            <el-form-item label="发布时间">
                                <span>{{ notificationTime }}</span>
                            </el-form-item>

                            <el-form label-position="top">
                                <el-form-item label="内容">
                                    <span>{{ notificationContent }}</span>
                                </el-form-item>
                            </el-form>
                        </el-form>
                    </div>
                    <div slot="footer" class="dialog-footer text-center">
                        <el-button @click="notificationDialogVisible = false">关 闭</el-button>
                    </div>
                </el-dialog>

                <el-dialog title="通知公告" id="mainDialog" class="formDialog" :visible.sync="moreNotificationDialogVisible"
                           width="90%">
                    <el-scrollbar id="infoDialogScroll" ref="infoDialogScroll">
                        <el-form label-width="130px" label-position="left" width="100%">
                            <div class="phoneList">
                                <div class="phoneListCard">
                                    <div class="listCard" v-for="(item,index) in notificationData">
                                        <div class="listCardText">
                                            <el-descriptions class="margin-top" title="" :column="1">
                                                <el-descriptions-item label="发布时间">{{ item.time }}
                                                </el-descriptions-item>
                                                <el-descriptions-item label="标题">{{ item.title }}
                                                </el-descriptions-item>
                                            </el-descriptions>
                                        </div>
                                        <div class="listCardBtn" style="text-align: right">
                                            <el-button type="info" size="small" @click="notificationDetail(item);">详情
                                            </el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </el-scrollbar>
                </el-dialog>
            </div>
        </div>
    </div>

</template>


<script>
import {confirmMsg, showNotify} from "utils/message";
import {} from 'utils/validate'; //验证组件
import {ajax} from 'utils/index';
import {globalConfig} from "../../../static/config";
import audit from "./audit";
import auditList from "./auditList";
import report from "../postPracticeManage/report";
import previewer from "views/file/simplePreviewer";
import summarys from "../postPracticeManage/summary";
import recordTable from "../postPracticeManage/recordTable";
import homecomingRecord from "../postPracticeManage/homecomingRecord";

export default {
    components: {
        auditList,
        previewer,
        summarys,
        recordTable,
        homecomingRecord,
        report
    },
    data() {
        return {
            activeName: 'first',
            tabPosition: 'bottom',
            user: {
                userCode: '',
                userName: '',
                userRoles: [],
            },
            tableHeight: 480,
            stuPracticeInfo: {
                stuCode: '',
                stuName: '',
                censusRegisterInfo: '',
                residentialAddress: '',
                homeTel: '',
                stuPhone: '',
                stuEmail: '',
                typeCode: '',
                unitName: '',
                postName: '',
                beginTime: '',
                endTime: '',
                salary: '',
                counterpart: '',
                teaching: '',
                putUp: '',
                unitContactsName: '',
                unitContactsDuty: '',
                unitContactsTel: '',
                unitContactsEmail: '',
                unitAddress: ''
            },
            practiceShowFlag: false,
            practiceInfoHeight: 0,

            notificationData: [],
            notificationTitle: '',
            notificationTime: '',
            notificationContent: '',
            notificationDialogVisible: false,

            applyDialogVisible: false,
            applyForm: {
                id: '',
                stuCode: '',
                stuName: '',
                censusRegisterInfo: '',
                residentialAddress: '',
                homeTel: '',
                stuPhone: '',
                stuEmail: '',
                unitName: '',
                postName: '',
                beginTime: '',
                endTime: '',
                salary: '',
                counterpart: '',
                teaching: '',
                putUp: '',
                unitContactsName: '',
                unitContactsDuty: '',
                unitContactsEmail: '',
                unitAddress: '',
                unitContactsTel: '',
                auditState: '',
                submitState: ''
            },
            applyRules: {
                beginTime: [{required: true, message: " ", trigger: ["blur", "change"],}],
                endTime: [{required: true, message: " ", trigger: ["blur", "change"],}],
                unitContactsName: [{required: true, message: " ", trigger: ["blur", "change"],}],
                unitContactsDuty: [{required: true, message: " ", trigger: ["blur", "change"],}],
                unitContactsTel: [{required: true, message: " ", trigger: ["blur", "change"],}],
                postName: [{required: true, message: " ", trigger: ["blur", "change"],}],
                unitName: [{required: true, message: " ", trigger: ["blur", "change"],}],
            },
            applySubmitStr: '',
            applyAuditStr: '',
            applyAuditStrColor: '',
            applyDelFlag: false,
            applyListDialogVisible: false,
            applyData: [],
            applyDialogTitle: '',
            applyFlag: false,
            applyNewFlag: false,

            changeDialogVisible: false,
            changeData: [],
            addChangeDialogVisible: false,
            addChangeDialogTitle: '',
            changeForm: {
                stuCode: '',
                id: '',
                unitName: '',
                postName: '',
                beginTime: '',
                endTime: '',
                salary: '',
                counterpart: '',
                putUp: '',
                unitContactsName: '',
                unitContactsDuty: '',
                unitContactsEmail: '',
                unitAddress: '',
                unitContactsTel: '',
                newUnitName: '',
                newPostName: '',
                newBeginTime: '',
                newEndTime: '',
                newSalary: '',
                newCounterpart: '',
                newPutUp: '',
                newUnitContactsName: '',
                newUnitContactsDuty: '',
                newUnitContactsEmail: '',
                newUnitAddress: '',
                newUnitContactsTel: '',

                auditState: '',
                submitState: ''
            },
            changeRules: {
                newBeginTime: [{required: true, message: " ", trigger: ["blur", "change"],}],
                newEndTime: [{required: true, message: " ", trigger: ["blur", "change"],}],
                newUnitContactsName: [{required: true, message: " ", trigger: ["blur", "change"],}],
                newUnitContactsDuty: [{required: true, message: " ", trigger: ["blur", "change"],}],
                newUnitContactsTel: [{required: true, message: " ", trigger: ["blur", "change"],}],
                newPostName: [{required: true, message: " ", trigger: ["blur", "change"],}],
                newUnitName: [{required: true, message: " ", trigger: ["blur", "change"],}],
            },
            changeFlag: false,

            completeDialogVisible: false,
            completeForm: {
                stuCode: '',
                stuName: '',
                censusRegisterInfo: '',
                residentialAddress: '',
                homeTel: '',
                stuPhone: '',
                stuEmail: ''
            },

            fileData: [],
            fileName: '',
            fileInfo: {
                name: '',
                type: '',
                url: ''
            },
            previewerDialogVisible: false,

            summaryData: [],
            summaryDialogVisible: false,
            summaryDialogTitle: '',
            summaryDialogTitleDate: '',
            summaryForm: {
                id: '',
                stuName: '',
                className: '',
                unitName: '',
                postName: '',
                score: '',
                content1: '',
                content2: '',
                content3: '',
                submitState: '',
                stuCode: '',
                evaluate: ''
            },
            summaryFlag: false,
            summaryTitle: '实习周记 / 出科小结（护理专业）',

            guidanceData: [],
            guidanceId: '',
            guidanceDialogVisible: false,

            practiceFlag: true,
            auditListDialogVisible: false,
            comboOption: {
                sf: [{'comboValue': '0', 'comboName': '是'}, {'comboValue': '1', 'comboName': '否'}],
            },
            loadingMask: null,
            auditRelatedCode: '',
            customLabelStyle: {
                'width': '10%',
            },
            customContentStyle: {
                'width': '15%',
            },

            homecomingDialogVisible: false,
            homecomingData: [],
            homecomingDetailDialogVisible: false,
            homecomingId: '',

            reportListDialogVisible: false,

            evaluationDialogVisible: false,
            evaluationData: [],
            evaluationCountScore: 0,
            evaluationState: false,

            infoDialogVisible: false,

            moreNotificationDialogVisible: false
        }
    },
    mounted() {
        this.userInfo();
        this.init();
    },
    methods: {
        showHomePage() {
            this.$router.push('/m/wx/home');
        },
        moreNotification() {
            this.moreNotificationDialogVisible = true
        },
        homecomingDetail(rowData) {
            this.homecomingId = rowData.id
            this.homecomingDetailDialogVisible = true
        },
        guidanceDetail(rowData) {
            this.guidanceId = rowData.id
            this.guidanceDialogVisible = true
        },
        summaryCallback() {
            this.loadSummary()
            this.summaryDialogVisible = false
        },
        summaryDetail(rowData) {
            this.summaryFlag = true;
            this.summaryForm.id = rowData.id
            this.summaryForm.score = rowData.score
            this.summaryForm.stuName = rowData.stuName
            this.summaryForm.className = rowData.className
            this.summaryForm.unitName = rowData.unitName
            this.summaryForm.postName = rowData.postName
            this.summaryForm.content1 = rowData.content1
            this.summaryForm.content2 = rowData.content2
            this.summaryForm.content3 = rowData.content3
            this.summaryForm.evaluate = rowData.evaluate
            this.summaryDialogTitle = this.summaryTitle;
            this.summaryDialogTitleDate = '（' + rowData.time.replace('~', ' ~ ') + '）';
            this.summaryDialogVisible = true
        },
        summaryEdit(rowData) {
            this.summaryFlag = false
            this.summaryForm.id = rowData.id
            this.summaryForm.stuName = rowData.stuName
            this.summaryForm.className = rowData.className
            if (rowData.unitName == '' || rowData.postName == '') {
                this.summaryForm.unitName = this.stuPracticeInfo.unitName
                this.summaryForm.postName = this.stuPracticeInfo.postName
            } else {
                this.summaryForm.unitName = rowData.unitName
                this.summaryForm.postName = rowData.postName
            }
            this.summaryForm.score = rowData.score
            this.summaryForm.content1 = rowData.content1
            this.summaryForm.content2 = rowData.content2
            this.summaryForm.content3 = rowData.content3
            this.summaryDialogTitle = this.summaryTitle;
            this.summaryDialogTitleDate = '（' + rowData.time.replace('~', ' ~ ') + '）';
            this.summaryDialogVisible = true
        },
        fileShow(rowData) {
            this.fileInfo.name = rowData.fileName;
            this.fileInfo.type = rowData.fileType;
            this.fileInfo.url = globalConfig.HOST_PROXY_ADMIN + globalConfig.fileApi + rowData.previewPath;
            this.fileName = rowData.fileName + '.' + rowData.fileType;
            this.previewerDialogVisible = true;
        },
        delFile(){
            this.$api.postPracticeManage.stuPractice.delFile({
                data: this.user.userCode
            }).then((res) => {
            }).catch((error) => {
            });
        },
        fileDownload(rowData) {
            const fileUrl = globalConfig.HOST_PROXY_ADMIN + globalConfig.fileApi;
            let exist = this.isExistFile(fileUrl+rowData.filePath);
            if (exist) {
                this.$api.postPracticeManage.stuPractice.download({
                    data: {
                        'filePath':rowData.filePath,
                        'fileName':rowData.fileName,
                        'fileType':rowData.fileType,
                        'stuCode':this.user.userCode
                    },
                }).then((res) => {
                    if(res.data.data !== 'fail'){
                        let furl = fileUrl+res.data.data;
                        //创建隐藏的下载链接
                        const link = document.createElement('a');
                        link.href = furl;
                        // link.target = '_blank';
                        // let fileName = rowData.fileName + '.' + rowData.fileType;
                        // link.setAttribute('download', fileName);
                        // 兼容性处理
                        if (navigator.userAgent.indexOf('Trident') > -1) { // IE浏览器
                            const ieDownloadFrame = document.createElement('iframe');
                            ieDownloadFrame.src = furl;
                            ieDownloadFrame.style.display = 'none';
                            document.body.appendChild(ieDownloadFrame);
                        } else if (navigator.userAgent.indexOf('Edge') > -1 || navigator.userAgent.indexOf('Edg') > -1) { // Edge浏览器
                            link.click(); // 直接触发链接点击事件
                        } else { // 其他浏览器
                            link.dispatchEvent(new MouseEvent('click'));
                        }
                    }
                }).catch((error) => {
                    showNotify('错误', error, 'error', 3000);
                });
            } else {
                showNotify('错误', '文件不存在，如有疑问请联系管理员！', 'error', 3000);
            }
        },
        isExistFile(url) {
            if (url == null || url == undefined || url == "") {
                return false;
            }
            let xmlhttp;
            if (window.XMLHttpRequest) {
                xmlhttp = new XMLHttpRequest();
            } else {
                xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
            }
            xmlhttp.open("GET", url, false);
            xmlhttp.send();
            if (xmlhttp.readyState == 4) {
                if (xmlhttp.status == 200) return true;
                //url存在
                else if (xmlhttp.status == 404) return false;
                //url不存在
                else return false; //其他状态
            }
        },
        evaluation() {
            this.evaluationDialogVisible = true
        },
        report() {
            this.reportListDialogVisible = true
        },
        completeSave() {
            this.$api.postPracticeManage.stuPractice.completeSave({
                data: this.completeForm,
            }).then((res) => {
                let state = res.data.data;
                switch (state) {
                    case 'success':
                        this.completeDialogVisible = false;
                        showNotify('成功', '保存成功', 'success', 1500);
                        this.loadPracticeInfo();
                        break;
                    default:
                        showNotify('错误', '保存失败', 'error', 3000);
                        break;
                }
            }).catch((error) => {
                showNotify('错误', error, 'error', 3000);
            });
        },
        complete() {
            this.completeForm.stuCode = this.stuPracticeInfo.stuCode
            this.completeForm.stuName = this.stuPracticeInfo.stuName
            this.completeForm.censusRegisterInfo = this.stuPracticeInfo.censusRegisterInfo
            this.completeForm.residentialAddress = this.stuPracticeInfo.residentialAddress
            this.completeForm.homeTel = this.stuPracticeInfo.homeTel
            this.completeForm.stuPhone = this.stuPracticeInfo.stuPhone
            this.completeForm.stuEmail = this.stuPracticeInfo.stuEmail
            this.completeDialogVisible = true
        },
        changeDel(rowData) {
            confirmMsg('是否确定要删除当前选择实习变更申请？', 'el-message-box-mobile').then(() => {
                this.$api.postPracticeManage.stuPractice.changeDel({
                    data: rowData.id,
                }).then((res) => {
                    let state = res.data.data;
                    switch (state) {
                        case 'success':
                            this.CurdDialogVisible = false;
                            showNotify('成功', '删除成功', 'success', 1500);
                            this.loadChangeInfo();
                            break;
                        default:
                            showNotify('错误', '删除失败', 'error', 3000);
                            break;
                    }
                }).catch((error) => {
                    showNotify('错误', error, 'error', 3000);
                });
                this.selectRowData = null;
            });
        },
        changeMod(rowData, type) {
            if (type === 'set') {
                this.addChangeDialogTitle = '编辑'
                this.changeFlag = true
            }

            if (type === 'view') {
                this.addChangeDialogTitle = '详情'
                this.changeFlag = false
            }
            this.changeForm.id = rowData.id
            this.changeForm.unitName = rowData.unitName
            this.changeForm.postName = rowData.postName
            this.changeForm.beginTime = rowData.beginTime
            this.changeForm.endTime = rowData.endTime
            this.changeForm.salary = rowData.salary
            this.changeForm.counterpart = rowData.counterpart
            this.changeForm.putUp = rowData.putUp
            this.changeForm.unitContactsName = rowData.unitContactsName
            this.changeForm.unitContactsDuty = rowData.unitContactsDuty
            this.changeForm.unitContactsEmail = rowData.unitContactsEmail
            this.changeForm.unitContactsTel = rowData.unitContactsTel
            this.changeForm.newUnitName = rowData.newUnitName
            this.changeForm.newPostName = rowData.newPostName
            this.changeForm.newBeginTime = rowData.newBeginTime
            this.changeForm.newEndTime = rowData.newEndTime
            this.changeForm.newSalary = rowData.newSalary
            this.changeForm.newCounterpart = rowData.newCounterpart
            this.changeForm.newPutUp = rowData.newPutUp
            this.changeForm.newUnitContactsDuty = rowData.newUnitContactsDuty
            this.changeForm.newUnitContactsName = rowData.newUnitContactsName
            this.changeForm.newUnitContactsEmail = rowData.newUnitContactsEmail
            this.changeForm.newUnitAddress = rowData.newUnitAddress
            this.changeForm.newUnitContactsTel = rowData.newUnitContactsTel
            this.changeForm.submitState = rowData.submitState;
            this.changeForm.auditState = rowData.auditState;
            this.addChangeDialogVisible = true
        },
        changeSave() {
            this.$refs['changeForm'].validate((valid) => {
                if (valid) {
                    if (this.changeForm.newBeginTime > this.changeForm.newEndTime) {
                        this.$message({
                            title: '提示',
                            message: '实习开始日期必须小于实习结束日期!',
                            type: 'warning',
                            duration: 2000,
                        });
                        return;
                    }
                    this.changeForm.submitState = '0'
                    this.showLoadingMask("保存中，请稍候...");
                    this.changeSaveMod()
                }
            })
        },
        changeSubmit() {
            this.$refs['changeForm'].validate((valid) => {
                if (valid) {
                    confirmMsg('提交后将无法再修改实习变更申请信息，是否继续？', 'el-message-box-mobile').then(() => {
                        if (this.changeForm.beginTime > this.changeForm.endTime) {
                            this.$message({
                                title: '提示',
                                message: '实习开始日期必须小于实习结束日期!',
                                type: 'warning',
                                duration: 2000,
                            });
                            return;
                        }
                        this.changeForm.submitState = '1';
                        this.changeForm.auditState = '';
                        this.showLoadingMask("提交中，请稍候...");
                        this.changeSaveMod()
                    });
                } else {
                    return false;
                }
            })
        },
        changeSaveMod() {
            this.$api.postPracticeManage.stuPractice.changeSave({
                data: this.changeForm,
            })
                .then((res) => {
                    let state = res.data.data;
                    if (state === 'success') {
                        this.$notify({
                            title: "成功",
                            message: "保存成功",
                            type: "success",
                            duration: 1500,
                        });
                        this.addChangeDialogVisible = false;
                        this.loadChangeInfo()
                    } else {
                        this.$notify({
                            title: "失败",
                            message: '保存失败',
                            type: "error",
                            duration: 3000,
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                }).finally(() => {
                this.closeLoadingMask();
            });
        },
        closeApply() {
            if (this.$refs['applyForm'] !== undefined) {
                this.$refs['applyForm'].clearValidate();
                this.$refs['applyForm'].resetFields();
            }
        },
        closeAddChange() {
            if (this.$refs['changeForm'] !== undefined) {
                this.$refs['changeForm'].clearValidate();
            }
        },
        newChange() {
            this.$api.postPracticeManage.stuPractice.inChange({
                data: this.user.userCode,
            }).then((res) => {
                if (res.data.data === false) {
                    this.alertMsg("正在申请实习变更中，请勿重复申请！")
                } else {
                    this.$api.postPracticeManage.stuPractice.inApply({
                        data: this.user.userCode,
                    }).then((res) => {
                        if (res.data.data === true) {
                            this.addChangeDialogTitle = '申请'
                            this.changeForm.unitName = this.stuPracticeInfo.unitName
                            this.changeForm.postName = this.stuPracticeInfo.postName
                            this.changeForm.beginTime = this.stuPracticeInfo.beginTime
                            this.changeForm.endTime = this.stuPracticeInfo.endTime
                            this.changeForm.salary = this.stuPracticeInfo.salary
                            this.changeForm.counterpart = this.stuPracticeInfo.counterpart
                            this.changeForm.putUp = this.stuPracticeInfo.putUp
                            this.changeForm.unitContactsName = this.stuPracticeInfo.unitContactsName
                            this.changeForm.unitContactsDuty = this.stuPracticeInfo.unitContactsDuty
                            this.changeForm.unitContactsEmail = this.stuPracticeInfo.unitContactsEmail
                            this.changeForm.unitContactsTel = this.stuPracticeInfo.unitContactsTel
                            this.changeForm.unitAddress = this.stuPracticeInfo.unitAddress
                            this.changeForm.newUnitName = ''
                            this.changeForm.newPostName = ''
                            this.changeForm.newBeginTime = ''
                            this.changeForm.newEndTime = ''
                            this.changeForm.newSalary = ''
                            this.changeForm.newCounterpart = ''
                            this.changeForm.newPutUp = ''
                            this.changeForm.newUnitContactsName = ''
                            this.changeForm.newUnitContactsDuty = ''
                            this.changeForm.newUnitContactsEmail = ''
                            this.changeForm.newUnitAddress = ''
                            this.changeForm.newUnitContactsTel = ''
                            this.changeFlag = true
                            this.addChangeDialogVisible = true
                        } else {
                            this.alertMsg("正在申请自主联系单位中，暂时无法进行实习变更申请")
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        change() {
            this.changeForm.stuCode = this.user.userCode
            this.loadChangeInfo()
            this.changeDialogVisible = true;
        },
        loadChangeInfo() {
            this.$api.postPracticeManage.stuPractice.loadChangeInfo({
                data: this.user.userCode,
            })
                .then((res) => {
                    this.changeData = res.data.data
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        applyDel(rowData) {
            confirmMsg('是否确定要删除当前选择自主联系单位申请？', 'el-message-box-mobile').then(() => {
                this.$api.postPracticeManage.stuPractice.applyDel({
                    data: rowData.id,
                }).then((res) => {
                    let state = res.data.data;
                    switch (state) {
                        case 'success':
                            showNotify('成功', '删除成功', 'success', 1500);
                            this.loadApplyInfo()
                            break;
                        default:
                            showNotify('错误', '删除失败', 'error', 3000);
                            break;
                    }
                }).catch((error) => {
                    showNotify('错误', error, 'error', 3000);
                });
            });
        },
        applyMod(rowData, type) {
            if (type === 'set') {
                this.applyDialogTitle = '编辑'
                this.applyFlag = true
            }

            if (type === 'view') {
                this.applyDialogTitle = '详情'
                this.applyFlag = false
            }

            this.applyForm.id = rowData.id
            this.applyForm.censusRegisterInfo = rowData.censusRegisterInfo
            this.applyForm.residentialAddress = rowData.residentialAddress
            this.applyForm.homeTel = rowData.homeTel
            this.applyForm.stuPhone = rowData.stuPhone
            this.applyForm.stuEmail = rowData.stuEmail
            this.applyForm.unitName = rowData.unitName
            this.applyForm.postName = rowData.postName
            this.applyForm.beginTime = rowData.beginTime
            this.applyForm.endTime = rowData.endTime
            this.applyForm.salary = rowData.salary
            this.applyForm.counterpart = rowData.counterpart
            this.applyForm.teaching = rowData.teaching
            this.applyForm.putUp = rowData.putUp
            this.applyForm.unitContactsName = rowData.unitContactsName
            this.applyForm.unitContactsDuty = rowData.unitContactsDuty
            this.applyForm.unitContactsEmail = rowData.unitContactsEmail
            this.applyForm.unitAddress = rowData.unitAddress
            this.applyForm.unitContactsTel = rowData.unitContactsTel

            this.applyDialogVisible = true
        },
        applySubmit() {
            this.$api.postPracticeManage.stuPractice.inChange({
                data: this.user.userCode,
            })
                .then((res) => {
                    if (res.data.data === true) {
                        this.$refs['applyForm'].validate((valid) => {
                            if (valid) {
                                confirmMsg('提交后将无法再修改自主联系单位申请信息，是否继续？', 'el-message-box-mobile').then(() => {
                                    if (this.applyForm.beginTime > this.applyForm.endTime) {
                                        this.$message({
                                            title: '提示',
                                            message: '实习开始日期必须小于实习结束日期!',
                                            type: 'warning',
                                            duration: 2000,
                                        });
                                        return;
                                    }
                                    this.applyForm.submitState = '1';
                                    this.applyForm.auditState = '';
                                    this.showLoadingMask("提交中，请稍候...");
                                    this.applySaveMod()
                                });
                            } else {
                                return false;
                            }
                        })
                    } else {
                        this.alertMsg("正在申请实习变更中，暂时无法进行自主联系单位申请")
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        applySave() {
            this.$api.postPracticeManage.stuPractice.inChange({
                data: this.user.userCode,
            })
                .then((res) => {
                    if (res.data.data === true) {
                        this.$refs['applyForm'].validate((valid) => {
                            if (valid) {
                                if (this.applyForm.beginTime > this.applyForm.endTime) {
                                    this.$message({
                                        title: '提示',
                                        message: '实习开始日期必须小于实习结束日期!',
                                        type: 'warning',
                                        duration: 2000,
                                    });
                                    return;
                                }
                                this.applyForm.submitState = '0'
                                this.showLoadingMask("保存中，请稍候...");
                                this.applySaveMod()
                            }
                        })
                    } else {
                        this.alertMsg("正在申请实习变更中，暂时无法进行自主联系单位申请")
                    }

                })
                .catch((err) => {
                    console.log(err);
                });
        },
        applySaveMod() {
            this.$api.postPracticeManage.stuPractice.applySave({
                data: this.applyForm,
            })
                .then((res) => {
                    let state = res.data.data;
                    if (state === 'success') {
                        this.$notify({
                            title: "成功",
                            message: "保存成功",
                            type: "success",
                            duration: 1500,
                        });
                        this.loadApplyInfo()
                        this.applyDialogVisible = false;
                    } else {
                        this.$notify({
                            title: "失败",
                            message: '保存失败',
                            type: "error",
                            duration: 3000,
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                }).finally(() => {
                this.closeLoadingMask();
            });
        },
        loadApplyInfo() {
            this.$api.postPracticeManage.stuPractice.loadApplyInfo({
                data: this.user.userCode,
            })
                .then((res) => {
                    this.applyData = res.data.data
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        showLoadingMask(str) {
            this.loadingMask = this.$loading({
                lock: true,
                text: str,
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.8)",
            });
        },
        newApply() {
            if (!this.applyNewFlag) {
                this.alertMsg("已完成自主联系单位申请，请勿重复申请")
                return;
            }

            this.$api.postPracticeManage.stuPractice.inApply({
                data: this.user.userCode,
            }).then((res) => {
                if (res.data.data === false) {
                    this.alertMsg("正在申请自主联系单位中，请勿重复申请")
                } else {
                    this.$api.postPracticeManage.stuPractice.inChange({
                        data: this.user.userCode,
                    }).then((res) => {
                        if (res.data.data === true) {
                            this.applyDialogTitle = '申请'

                            this.applyForm.censusRegisterInfo = '';
                            this.applyForm.residentialAddress = '';
                            this.applyForm.homeTel = '';
                            this.applyForm.stuPhone = '';
                            this.applyForm.stuEmail = '';
                            this.applyForm.unitName = '';
                            this.applyForm.postName = '';
                            this.applyForm.beginTime = '';
                            this.applyForm.endTime = '';
                            this.applyForm.salary = '';
                            this.applyForm.counterpart = '';
                            this.applyForm.teaching = '';
                            this.applyForm.putUp = '';
                            this.applyForm.unitContactsName = '';
                            this.applyForm.unitContactsDuty = '';
                            this.applyForm.unitContactsEmail = '';
                            this.applyForm.unitAddress = '';
                            this.applyForm.unitContactsTel = '';

                            this.applyDialogVisible = true
                            this.applyFlag = true
                        } else {
                            this.alertMsg("正在申请实习变更中，暂时无法进行自主联系单位申请")
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                }
            }).catch((err) => {
                console.log(err);
            });
        },

        //显示审核详情列表
        showAuditList(id) {
            this.auditRelatedCode = id
            this.auditListDialogVisible = true;
        },
        loadStateImg(row) {
            if (row.auditState === '1') {
                return require('image/mobile/auditState/tg.png');
            } else if (row.auditState === '2') {
                return require('image/mobile/auditState/bh.png');
            } else {
                if (row.submitState === '1') {
                    if (row.auditLevel === '1') {
                        return require('image/mobile/auditState/dsh.png');
                    } else {
                        return require('image/mobile/auditState/shz.png');
                    }
                } else {
                    return require('image/mobile/auditState/wtj.png');
                }
            }
        },
        apply() {
            this.$api.postPracticeManage.stuPractice.newApply({
                data: this.user.userCode,
            }).then((res) => {
                this.applyNewFlag = res.data.data
                this.applyForm.stuCode = this.user.userCode
                this.applyForm.stuName = this.user.userName
                this.loadApplyInfo()
                this.applyListDialogVisible = true
            }).catch((err) => {
                console.log(err);
            });
        },
        info() {
            this.infoDialogVisible = true
        },
        timeRangeFormatter(row) {
            return row.time.replace('~', ' ~ ');
        },
        submitStateFormatter(row) {
            return row.submitState === '1' ? '已提交' : '未提交';
        },
        evaluateStateFormatter(row) {
            if (row.score == null) {
                return '未评阅'
            } else {
                return '已评阅'
            }
        },
        auditStateFormatter(row) {
            let str = '';

            if (row.auditState === '1') {
                str = '通过';
            } else if (row.auditState === '2') {
                str = '驳回';
            } else {
                if (row.submitState === '1') {
                    if (row.auditLevel === '1') {
                        str = '待审核';
                    } else {
                        str = '审核中';
                    }
                } else {
                    str = '未提交';
                }
            }

            return str;
        },
        parsePracticeType(str) {
            if (str === '1') {
                return '学校推荐'
            } else if (str === '2') {
                return '自主联系'
            } else
                return ''
        },
        parseSf(str) {
            if (str === '1') {
                return '是'
            } else if (str === '0') {
                return '否'
            } else
                return ''
        },
        parseAttendance(rowData) {
            let str = ''
            if (rowData.state === '1') {
                str = '出勤'
            } else if (rowData.state === '0') {
                str = '缺勤'
            }
            return str;
        },
        userInfo() {
            this.$api.system.basic.userInfo({}).then((res) => {
                const userInfo = res.data.data;
                if (userInfo) {
                    this.user.userCode = userInfo.phone;
                    this.user.userName = userInfo.name;
                    for (let roleCode in userInfo.roles) {
                        this.user.userRoles.push(roleCode);
                    }

                    // this.user.userCode = '272617124'
                    // this.user.userName = '荘静雯'
                    // this.user.userRoles.push('8')

                    this.delFile();
                    if (this.user.userRoles.indexOf(globalConfig.auth.xs) > -1) {
                        this.loadPracticeInfo();
                        this.loadNotification()
                        this.loadFile();
                        this.loadSummary();
                        this.loadGuidance();
                        this.loadEvaluation();
                        this.loadHomecomingInfo()
                    }
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        loadHomecomingInfo() {
            this.$api.postPracticeManage.stuPractice.loadHomecomingInfo({
                data: this.user.userCode,
            }).then((res) => {
                this.homecomingData = res.data.data
            }).catch((err) => {
                console.log(err);
            });
        },
        loadEvaluation() {
            this.$api.postPracticeManage.stuEvaluation.query({
                data: this.user.userCode,
            })
                .then((res) => {
                    this.evaluationData = res.data.data.info;
                    this.evaluationCountScore = res.data.data.countScore;

                    if (this.evaluationData.length === 0) {
                        this.evaluationState = false
                    } else
                        this.evaluationState = true

                })
                .catch((err) => {
                    console.log(err);
                });
        },
        loadGuidance() {
            this.$api.postPracticeManage.stuPractice.loadGuidance({
                data: this.user.userCode,
            }).then((res) => {
                this.guidanceData = res.data.data
            }).catch((err) => {
                console.log(err);
            });
        },
        loadSummary() {
            this.$api.postPracticeManage.stuPractice.loadSummary({
                data: this.user.userCode,
            })
                .then((res) => {
                    this.summaryData = res.data.data.info
                    this.summaryTitle = res.data.data.title
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        loadFile() {
            this.$api.postPracticeManage.stuPractice.loadFile({
                data: this.user.userCode,
            })
                .then((res) => {
                    this.fileData = res.data.data
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        loadNotification() {
            this.$api.postPracticeManage.stuPractice.loadNotification({
                data: this.user.userCode,
            })
                .then((res) => {
                    this.notificationData = res.data.data
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        notificationDetail(rowData) {
            this.notificationTitle = rowData.title;
            this.notificationTime = rowData.time;
            this.notificationContent = rowData.content;
            this.notificationDialogVisible = true;
        },
        loadPracticeInfo() {
            this.$api.postPracticeManage.stuPractice.loadPracticeInfo({
                data: this.user.userCode,
            })
                .then((res) => {
                    if (res.data.data === null) {
                        this.practiceFlag = true
                    } else {
                        this.practiceFlag = false
                        this.stuPracticeInfo = res.data.data
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        /**关闭loading**/
        closeLoadingMask() {
            if (this.loadingMask) this.loadingMask.close();
        },
        alertMsg(str) {
            this.$message({
                message: str,
                type: 'warning'
            });
        },

        init() {

        },
        handleClick(tab, event) {

        }
    }
}
</script>

<style src="styles/mobile.css"/>
<style>
.auditStateImg {
    width: 100px;
    height: 100px;
    position: absolute;
    right: 0;
    top: 0;
}

#infoDialogScroll {
    height: 65vh;
    padding: 10px 20px;
}


#nhMainPhone {
    width: 100%;
    height: 100vh;
}

/*********************** 中心 ***********************/
#nhMainPhone .phoneMainBox {
    background-color: #f8f8f8;
    /* overflow-y: auto; */
    padding: 0 !important;
    position: relative;
}

#nhMainPhone .phoneMain {
    background-color: #fff;
    border-radius: 5px;
    margin: 10px 0;
}

/* 切换tab */
#nhMainPhone .phoneMainBox .el-tabs__header {
    /* border: 1px red solid; */
    position: fixed;
    height: 60px;
    bottom: 0;
    width: 100%;
    background-color: #f8f8f8;
    z-index: 2;
}

/* 导航 */
#nhMainPhone .phoneMainBox .el-tabs__header .el-tabs__nav {
    width: 100%;
}

#nhMainPhone .phoneMainBox .el-tabs__header .el-tabs__active-bar {
    width: 25%;
}

#nhMainPhone .phoneMainBox .el-tabs__header .el-tabs__item {
    height: 60px;
    line-height: 60px;
    width: 25% !important;
    text-align: center;
    padding: 0;
}

#nhMainPhone .phoneMainBox .tabTitleBox {
    font-size: 0.9em;
    text-align: center;
    height: 100%;
    width: 100%;
    display: block;
    float: left;
    line-height: 20px;
}

#nhMainPhone .phoneMainBox .tabTitleBox i,
#nhMainPhone .phoneMainBox .tabTitleBox span {
    display: block;
}

#nhMainPhone .phoneMainBox .tabTitleBox i {
    font-size: 25px;
    padding: 8px 0 5px 0;
}

#nhMainPhone .phoneMainBox .el-tabs__content {
    /* margin-top: 60px; */
    padding: 10px;
    margin-bottom: 60px;
}

/* 标题 */
#nhMainPhone .phoneTitle {
    border-bottom: 3px #6da1d6 solid;
    position: relative;
}

#nhMainPhone .phoneTitle h3 {
    display: inline-block;
    margin: 20px 10px 15px 10px;
    color: #0055AA;
}

#nhMainPhone .phoneTitle.twoTitle {
    display: inline-block;
    padding: 0 5px;
    border-bottom: 4px #6da1d6 double;
}

#nhMainPhone .phoneTitle.twoTitle h3 {
    margin: 20px 10px 5px 10px;
    color: #000;
}

/* 轮播图 */
#nhMainPhone .phoneMainBox .el-carousel__container {
    margin-top: 10px;
    height: 180px;
}

#nhMainPhone .phoneMainBox .el-carousel__item {
    background-image: url(../../../image/mobile/noticebg.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    padding: 4% 30% 0 20px;
    color: #fff;
    border-radius: 8px;
}

#nhMainPhone .phoneMainBox .el-carousel__item h3 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4; /*行数*/
    -webkit-box-orient: vertical;
}

/* 按钮组 */
#nhMainPhone .phoneMain .iconBtnGroup {
    padding: 10px;
    overflow: overlay;
    margin: 10px 0;
}

#nhMainPhone .phoneMain .iconBtnGroup .iconBtn {
    width: 33.3%;
    display: inline-block;
    float: left;
    text-align: center;
    margin: 5px 0;
}

#nhMainPhone .phoneMain .iconBtnGroup .iconBtn:nth-child(odd) i {
    color: #67c23a;
    background: #f0f9eb;
    border-color: #c2e7b0;
}

#nhMainPhone .phoneMain .iconBtnGroup .iconBtn:nth-child(even) i {
    color: #e6a23c;
    background: #fdf6ec;
    border-color: #f5dab1;
}

#nhMainPhone .phoneMain .iconBtnGroup i {
    /* border: 1px red solid; */
    display: inline-block;
    padding: 13px;
    border-radius: 10px;
    font-size: 2em;
    color: #fff;
}

#nhMainPhone .phoneMain .iconBtnGroup p {
    margin: 0;
    padding: 8px 0;
    font-size: 14px;
}

/* 卡片 */
#nhMainPhone .phoneMain .phoneListCard {
    /* border: 1px red solid; */
    padding: 20px;
}

#nhMainPhone .phoneMain .phoneListCard .listCard {
    box-shadow: 0 0 10px #e7e7e7;
    width: 100%;
    border-radius: 5px;
    margin-bottom: 15px;
}

#nhMainPhone .phoneMain .phoneListCard .listCardText {
    /* border: 1px red solid; */
    padding: 10px 12px;
}

#nhMainPhone .phoneMain .phoneListCard .listCardBtn {
    border-top: 1px #f9f9f9 solid;
    padding: 10px;
    text-align: right;
    /* height: 40px; */
}

#nhMainPhone .phoneMain .phoneListCard .listCardText .el-descriptions-item__label {
    width: 75px;
    font-weight: bold;
    letter-spacing: 1px;
    display: inline-block;
    line-height: 30px;
    font-size: 15px;
}

#nhMainPhone .phoneMain .phoneListCard .listCardText .el-descriptions-item__content {
    /*css代码：*/
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3; /*行数*/
    -webkit-box-orient: vertical;
    line-height: 30px;
}

.topButton {
    position: absolute;
    top: 30px;
    right: 20px;
    z-index: 99999;
}
</style>



// WEBPACK FOOTER //
// stuPracticeMobile.vue?26db249e